/**
 * MT Custom Cursor
 * 自定义圆圈光标效果，支持平滑过渡动画和自适应反色
 * 
 * 使用方式：
 * 在需要圆圈光标的元素上添加 class="mt-cursor-circle"
 */

(function() {
  'use strict';

  // 仅在桌面端且支持 hover 的设备上启用
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  let customCursor = null;
  let cursorX = 0;
  let cursorY = 0;
  let currentX = 0;
  let currentY = 0;
  let isHovering = false;
  let animationFrame = null;

  // 创建自定义光标元素
  function createCursor() {
    customCursor = document.createElement('div');
    customCursor.className = 'mt-custom-cursor';
    customCursor.innerHTML = `
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="29" stroke="white" stroke-width="2"/>
      </svg>
    `;
    document.body.appendChild(customCursor);

    // 添加样式
    const style = document.createElement('style');
    style.textContent = `
      /* Hide default cursor on interactive elements */
      .mt-cursor-circle {
        cursor: none !important;
      }

      .mt-custom-cursor {
        position: fixed;
        top: 0;
        left: 0;
        width: 45px;
        height: 45px;
        pointer-events: none;
        z-index: 10000;
        opacity: 0;
        transform: translate(-50%, -50%) scale(0);
        transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
                    transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        will-change: transform, opacity;
        mix-blend-mode: difference;
      }

      .mt-custom-cursor.active {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }

      .mt-custom-cursor svg {
        width: 100%;
        height: 100%;
        display: block;
      }

      /* Touch device fallback */
      @media (hover: none) or (pointer: coarse) {
        .mt-cursor-circle {
          cursor: auto !important;
        }
      }
    `;
    
    // 检查是否已存在相同的样式
    if (!document.querySelector('#mt-custom-cursor-style')) {
      style.id = 'mt-custom-cursor-style';
      document.head.appendChild(style);
    }
  }

  // 更新光标位置
  function updateCursorPosition(e) {
    cursorX = e.clientX;
    cursorY = e.clientY;
  }

  // 动画循环
  function animate() {
    // 使用 lerp 实现平滑跟随
    const ease = 0.15;
    currentX += (cursorX - currentX) * ease;
    currentY += (cursorY - currentY) * ease;

    if (customCursor) {
      customCursor.style.left = `${currentX}px`;
      customCursor.style.top = `${currentY}px`;
    }

    animationFrame = requestAnimationFrame(animate);
  }

  // 显示光标
  function showCursor() {
    if (!isHovering && customCursor) {
      isHovering = true;
      customCursor.classList.add('active');
    }
  }

  // 隐藏光标
  function hideCursor() {
    if (isHovering && customCursor) {
      isHovering = false;
      customCursor.classList.remove('active');
    }
  }

  // 绑定事件到所有带 mt-cursor-circle 类的元素
  function bindEvents() {
    const elements = document.querySelectorAll('.mt-cursor-circle');
    
    elements.forEach(element => {
      element.addEventListener('mouseenter', showCursor);
      element.addEventListener('mouseleave', hideCursor);
    });
  }

  // 初始化
  function init() {
    createCursor();
    animate();
    bindEvents();

    // 监听鼠标移动
    document.addEventListener('mousemove', updateCursorPosition);

    // 监听 DOM 变化，自动绑定新添加的元素
    const observer = new MutationObserver(() => {
      bindEvents();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // 等待 DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify 主题编辑器支持
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(bindEvents, 100);
    });
  }
})();
